import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { getVehicleMsrp, getVehiclePrice } from "src/store/selectors/vehicles";
import { VehicleState } from "Types/state";
import Msrp from "./Msrp";

function mapStateToProps(state: ApplicationStore, props: { vehicle: VehicleState } | { vin: string }) {
    const vin = "vehicle" in props ? props.vehicle.vin : props.vin;

    return {
        account: state.account,
        msrp: getVehicleMsrp(state, vin),
        price: getVehiclePrice(state, vin),
    };
}

export default connect(mapStateToProps)(Msrp);
